import { Visibility } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { toCapitalized } from '../../../Utils/Capitalize';

const InfoRow = ({ label, value, onViewClick, error }) => (
  <Box sx={{ mb: 2 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, gap: 8 }}>
      <Typography variant="labelD" sx={{ color: '#666' }}>
        {label}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {label === 'Identification proof' ? (
          error ? (
            <Typography variant="body2" sx={{ color: '#CC0000', fontSize: '14px', textAlign: 'right' }}>
              {error}
            </Typography>
          ) : (
            <IconButton size="small" onClick={() => onViewClick(value)}>
              <Visibility fontSize="small" />
            </IconButton>
          )
        ) : (
          <Typography variant="body1" sx={{ color: '#333', textAlign: 'right' }}>
            {value || '-'}
          </Typography>
        )}
      </Box>
    </Box>

  </Box>
);

export default InfoRow;
